"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iBriefcase = void 0;
const t = require("io-ts");
const file_1 = require("./file");
exports.iBriefcase = t.intersection([
    file_1.iFolder,
    t.interface({
        projectName: t.string,
        open: t.number,
        closed: t.number,
        draft: t.number,
        total: t.number
    }),
    t.partial({
        description: t.union([t.string, t.null]),
        reliablePartnerCompanyName: t.union([t.null, t.string])
    })
]);
//# sourceMappingURL=briefcase.js.map